module.exports = [
  {
    id: 1,
    tag: "LIKELY TO SELL OUT*",
    slideImg: [
      "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=800&q=85&fit=crop",
      "https://images.unsplash.com/photo-1548094878-84ced0f5-d1a1-4a8f-9b8e-7d6e7c8b9d0a?w=800&q=85&fit=crop",
      "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&q=85&fit=crop",
    ],
    title: "Stonehenge, Windsor Castle and Bath with Pub Lunch in Lacock",
    location: "Westminster Borough, London",
    duration: "16",
    numberOfReviews: "3014",
    price: "72",
    tourType: "Full-day Tours",
    delayAnimation: "100",
  },
  {
    id: 2,
    tag: "",
    slideImg: [
      // Wadi Shab turquoise pools
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=85&fit=crop",
      // Wadi canyon gorge
      "https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&q=85&fit=crop",
      // Clear mountain water pool
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=85&fit=crop",
    ],
    title: "Westminster Walking Tour & Westminster Abbey Entry",
    location: "Ciutat Vella, Barcelona",
    duration: "14",
    numberOfReviews: "2045",
    price: "65",
    tourType: "Attractions & Museums",
    delayAnimation: "200",
  },

  {
    id: 3,
    tag: "best seller",
    slideImg: [
      // Sultan Qaboos Grand Mosque exterior
      "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&q=85&fit=crop",
      // Muscat old souq & architecture
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73f6e?w=800&q=85&fit=crop",
      // Mutrah Corniche harbour
      "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=85&fit=crop",
    ],
    title: "High-Speed Thames River RIB Cruise in London",
    location: "Manhattan, New York",
    duration: "18",
    numberOfReviews: "2163",
    price: "87",
    tourType: "Private and Luxury",
    delayAnimation: "300",
  },
  {
    id: 4,
    tag: "top rated",
    slideImg: [
      // Jebel Akhdar rose valley terraces
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&q=85&fit=crop",
      // Al Hajar mountain road dramatic
      "https://images.unsplash.com/photo-1519449556851-5720b33024e7?w=800&q=85&fit=crop",
      // Mountain viewpoint sunrise
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800&q=85&fit=crop",
    ],
    title: "Edinburgh Darkside Walking Tour: Mysteries, Murder and Legends",
    location: "Vaticano Prati, Rome",
    duration: "20",
    numberOfReviews: "1458",
    price: "99",
    tourType: "Bus Tours",
    delayAnimation: "400",
  },
  {
    id: 5,
    tag: "LIKELY TO SELL OUT*",
    slideImg: [
      // Musandam fjords dhow boat
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&q=85&fit=crop",
      // Crystal clear Arabian Sea
      "https://images.unsplash.com/photo-1500375592092-40eb2168fd21?w=800&q=85&fit=crop",
      // Dhow sailing traditional
      "https://images.unsplash.com/photo-1518877593221-1f28583780b4?w=800&q=85&fit=crop",
    ],
    title: "Stonehenge, Windsor Castle and Bath with Pub Lunch in Lacock",
    location: "Westminster Borough, London",
    duration: "16",
    numberOfReviews: "3014",
    price: "72",
    tourType: "Full-day Tours",
    delayAnimation: "100",
  },
  {
    id: 6,
    tag: "",
    slideImg: [
      // Nizwa fort iconic round tower
      "https://images.unsplash.com/photo-1590736969596-3e1fc6c94ec9?w=800&q=85&fit=crop",
      // Nizwa souq goat market
      "https://images.unsplash.com/photo-1527576539890-dfa815648363?w=800&q=85&fit=crop",
      // Ancient falaj irrigation Oman
      "https://images.unsplash.com/photo-1545072979-c67f5bd10f04?w=800&q=85&fit=crop",
    ],
    title: "Westminster Walking Tour & Westminster Abbey Entry",
    location: "Ciutat Vella, Barcelona",
    duration: "14",
    numberOfReviews: "2045",
    price: "65",
    tourType: "Attractions & Museums",
    delayAnimation: "200",
  },
  {
    id: 7,
    tag: "best seller",
    slideImg: [
      // Salalah Khareef green mountains
      "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=800&q=85&fit=crop",
      // Frankincense trees Dhofar
      "https://images.unsplash.com/photo-1542202229-7d93c33f5d07?w=800&q=85&fit=crop",
      // Tropical coast Salalah
      "https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=800&q=85&fit=crop",
    ],
    title: "High-Speed Thames River RIB Cruise in London",
    location: "Manhattan, New York",
    duration: "18",
    numberOfReviews: "2163",
    price: "87",
    tourType: "Private and Luxury",
    delayAnimation: "300",
  },
  {
    id: 8,
    tag: "top rated",
    slideImg: [
      // Sur turtle beach Ras al Jinz
      "https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?w=800&q=85&fit=crop",
      // Green sea turtle nesting
      "https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=800&q=85&fit=crop",
      // Sur dhow shipyard coastline
      "https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?w=800&q=85&fit=crop",
    ],
    title: "Edinburgh Darkside Walking Tour: Mysteries, Murder and Legends",
    location: "Vaticano Prati, Rome",
    duration: "20",
    numberOfReviews: "1458",
    price: "99",
    tourType: "Bus Tours",
    delayAnimation: "400",
  },
  {
    id: 9,
    tag: "best seller",
    slideImg: [
      // Stargazing desert camp Oman night sky
      "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&q=85&fit=crop",
      // Milky Way desert MENA
      "https://images.unsplash.com/photo-1442850473887-0fb77cd0b337?w=800&q=85&fit=crop",
      // Luxury desert camp fire
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&q=85&fit=crop",
    ],

    title: "High-Speed Thames River RIB Cruise in London",
    location: "Manhattan, New York",
    duration: "18",
    numberOfReviews: "2163",
    price: "87",
    tourType: "Private and Luxury",
    delayAnimation: "500",
  },
];
